//
//
//
//
//
//
//
//
//
//
//
//

import store from "@/store";
export default {
  data: function data() {
    return {
      isTranslate: localStorage.getItem("isTranslate") || "0"
    };
  },
  computed: {
    language: function language() {
      return this.$store.state.app.language;
    }
  },
  methods: {
    clickOptionsTranslate: function clickOptionsTranslate(lang) {
      console.log("clickOptionsTranslate", lang);
      localStorage.setItem("isTranslate", lang);
      console.log(localStorage.getItem("isTranslate"));
      // 刷新当前页面
      window.location.reload();
    }
  }
};